"use client";
import { useLayoutEffect, useState, useCallback, useEffect, useContext, JSX } from "react";
import { TabNav } from "@radix-ui/themes";
import TabItem, { TextLinkType } from "./tabItem";
import { SectionProps } from "@/components/common/interface/interfaces";
import { Debug } from "@/util/debug";
import { changeUserAuthSelect, checkUserPageAuth, checkUsertypeCRUD, getUserAuthData, getUserAuthSessions } from "@/util/authutil";
import { DataInputParams } from "../input/inputType";
import { AuthList } from "../layoutType";
import { Select } from "../input";
import * as dc from "@/components/layout/list/defaultType";
import { Form } from "antd";
import { AlertContext } from "@/components/context/alertContext";
import { useTranslations } from "next-intl";
import { enLocale } from "@/i18n/routing";

export default function Tab(props: SectionProps) {
  const menu = props.params?.menu?.tab_list ?? [];
  const [isLoading, setIsLoading] = useState(props.params?.menu?.tab_loading ?? true);

  const usertype = props.params?.user?.usertype;
  const tabAuth = props.params?.auth;
  const params = props.params;

  const [authSelect, setAuthSelect] = useState<JSX.Element[] | undefined>(undefined);
  const alertContext = useContext(AlertContext);
  const ta = useTranslations("alert");

  useEffect(() => {
    const auth_select_list: JSX.Element[] = [];
    const auth_list = params?.user?.userseq !== undefined ? getUserAuthSessions(params?.page?.auth) : undefined;
    if (auth_list) {
      Object.keys(auth_list).forEach((key) => {
        const temp_list = auth_list[key];
        if (temp_list.list && temp_list.list.length > 0) {
          const value = temp_list.select ?? temp_list.list[0].auth_seq;
          const select_params: DataInputParams = {
            ...dc.select,
            inputClassName: dc.inputSelectWidth,
            variant: "borderless",
            value: value,
            defaultValue: value,
            values: [],
            name: key + "_select",
            selectPropOption: {
              reloadButtonClassName: "-ml-7",
              reloadButtonType: "text",
              reloadButton: true,
              reloadButtonClick: (setValueList, setLoading) => {
                getUserAuthData([key], params?.user?.userseq, undefined, undefined, (data: any) => {
                  if (data.change) {
                    const change_list: AuthList[] = data.result[key + "_auth"];
                    if (change_list) {
                      const refreshValueList = change_list.map((item) => {
                        return { value: item.auth_seq, label: params?.locale === enLocale ? item.auth_name : item.auth_name_locale };
                      });
                      setValueList(refreshValueList);
                    }
                  } else {
                    if (alertContext.setProp) {
                      alertContext.setProp({
                        open: true,
                        title: ta("refresh"),
                        description: ta("refresh_not_changed"),
                        useCancel: false,
                        useOk: true,
                        //okFunction: () => {},
                      });
                    }
                  }
                  setLoading(false);
                });
              },
            },
            allowClear: false,
            selectProp: { suffixIcon: <></>, styles: { popup: { root: { textAlign: "end" } } } }, //<Icon iconType="" iconName="SortAscending" />
            onChange: (e) => {
              if (e !== null && e.value && e.value !== "" && e.value !== auth_list[key].select && changeUserAuthSelect(key, e.value)) {
                // Debug(params?.page);
                if (params?.page?.link && !params?.page?.article_use) {
                  location.href = params.page.link;
                  history.pushState(null, "", params.page.link);
                  //router.push(params.page.link);
                } else {
                  location.href = location.href;
                  // history.pushState(null, "", location.href);
                }
              }
            },
          };

          select_params.valueList = temp_list.list.map((item) => {
            return { value: item.auth_seq, label: params?.locale === enLocale ? item.auth_name : item.auth_name_locale };
          });
          //Debug(select_params);
          auth_select_list.push(<Select key={key + "_select"} {...select_params} />);
        }
      });
    }
    //Debug(auth_select_list);
    if (auth_select_list.length > 0) {
      setAuthSelect(auth_select_list);
    } else {
      setAuthSelect(undefined);
    }
  }, [
    params?.locale,
    params?.page?.auth,
    params?.page?.link,
    params?.user?.userseq,
    params?.auth,
    params?.page?.article_use,
    alertContext,
    ta,
  ]);
  useLayoutEffect(() => {
    setIsLoading(false);
  }, []);
  return (
    <TabNav.Root className={props.className} aria-label="MainNav">
      {menu.map((item, index) => {
        //Debug("Tab item", item, item.list);
        if ((item.display ?? true) && checkUsertypeCRUD(usertype, item.list)) {
          // if (item.auth) {
          //   Debug("Tab UserPageAuth", tabAuth, checkUserPageAuth(usertype, tabAuth, item, true));
          // }
          if (!item.auth || (item.auth && checkUserPageAuth(usertype, tabAuth, item, true).menu)) {
            return (
              <TabItem
                key={"tab_" + index}
                link={item}
                loading={isLoading}
                active={item.path == props.params?.menu?.tab_id}
                props={props}
              />
            );
          }
        }
      })}
      {authSelect ? (
        <TabNav.Link className="auth_select">
          <Form>{authSelect}</Form>
        </TabNav.Link>
      ) : (
        ""
      )}
    </TabNav.Root>
  );
}
